import WebApi from '@/views/loyalty/shared/modules/web_api'
import { unwrapEnvelope, buildQuery } from '@/views/skud/shared/modules/skud-http'

export class SkudPassageEndpoint {
  constructor () {
    this.url = `${process.env.VUE_APP_CHARON_URL}api/management/`
    this.webApi = new WebApi()
  }

  // params: from,to,screen,offline,revised,suspicious,method,reason,
  // point_id,direction,subject_ref,group_ref,limit,cursor_occurred_at,cursor_id — все опциональны.
  // placeId не задан -> client-scope GET /passages.
  // -> {items, next_cursor_occurred_at, next_cursor_id} или null.
  async getPassages (placeId, params) {
    const seg = placeId ? 'places/' + placeId + '/' : ''
    const res = await this.webApi.get(this.url + seg + 'passages?' + buildQuery(params || {}))
    this.lastError = res
    return unwrapEnvelope(res)
  }

  // -> объект прохода или null.
  async getPassage (placeId, publicId) {
    const res = await this.webApi.get(this.url + 'places/' + placeId + '/passages/' + publicId)
    this.lastError = res
    return unwrapEnvelope(res)
  }
}
